import React, { Suspense, useState, useEffect, useRef } from 'react'
import '../Registration/Registration.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
  useHistory,
  Redirect,
} from 'react-router-dom'
import { Button } from 'reactstrap'
import Loading from '../../components/Loading'
import Header from '../../DefaultLayout/Header'
import Footer from '../../DefaultLayout/Footer'
import { useDispatch, connect } from 'react-redux'
import firebase from '../../Helpers/firebase'
import { countryCodes } from '../../Helpers/countryCodeList'
import { toast } from 'react-toastify'
import ToastifyContainer from '../../components/Toastify/ToastifyContainer'
import {
  RandomNumber,
  checkEmptyValidation,
} from '../../Helpers/Validation'
import DashboardNavbar from '../../DefaultLayout/DashboardNavbar'
import { 
  CircularProgress,
} from "@mui/material"; 

function New_registration_otp(props) {
  const { frontLabelsName } = props.label
  const { isAuthenticated, loading } = props.auth

  const [mobileNumber, setMobileNumber] = useState('')
  const [countryCode, setCountryCode] = useState('+354')
  const [loading1, setLoading] = useState(false)
  const [error_phone_number, setError_phone_number] = useState('')
  window.scrollTo({ top: 0 });
  const dispatch = useDispatch()

  const reCaptchRef = useRef()

  const history = useHistory()

  useEffect(() => {
    var duration = 1000
    setTimeout(() => {
      configureCaptcha()
    }, duration)
  }, [])

//   const configureCaptcha = () => {

//     if (window.recaptchaVerifier) {
//       window.recaptchaVerifier.clear(); // Clear old captcha if exists
//     }

//     window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
//       'sign-in-button',
//       {
//         size: 'invisible',
//         callback: (response) => {
//           // reCAPTCHA solved, allow signInWithPhoneNumber.
//           handleOtp()
//         },
//         'expired-callback': () => {
//           console.log('Captcha expired 🔄 re-rendering...');
//           configureCaptcha(); // Reconfigure again
//         }
//       }
//     )
//     window.recaptchaVerifier.render().then(function (widgetId) {
//       window.recaptchaWidgetId = widgetId
//     })
  
// }

const configureCaptcha = () => {
  return new Promise((resolve, reject) => {
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();
      window.recaptchaVerifier = null;
    }

    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
      size: 'invisible', // 👈 Invisible mode
      callback: (response) => {
        console.log('reCAPTCHA solved automatically');
        resolve(); // Automatically resolve once solved
      },
      'expired-callback': () => {
        console.log('Captcha expired 🔄 Reconfiguring...');
        configureCaptcha(); // Retry configure if expired
      }
    });

    window.recaptchaVerifier.render()
      .then((widgetId) => {
        window.recaptchaWidgetId = widgetId;
        console.log('Invisible reCAPTCHA rendered.');
        resolve();
      })
      .catch((err) => {
        console.error('Failed to render invisible reCAPTCHA:', err);
        reject(err);
      });
  });
};

  const handleOtp = async(e) => {
    e.preventDefault()
    let errPhoneNumber = null
    let validationFlag = true

    errPhoneNumber = checkEmptyValidation(mobileNumber, 'lbl_mobile_number')

    if (errPhoneNumber) {
      validationFlag = false
      setError_phone_number(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errPhoneNumber).length > 0
            ? frontLabelsName.filter((e) => e.key == errPhoneNumber)[0]['value'] ||
              errPhoneNumber
            : errPhoneNumber
          : errPhoneNumber
      )
    } else {
      validationFlag = true
      setError_phone_number('')
    }

    if (validationFlag) {
      setLoading(true)
     try{
    if (!window.recaptchaVerifier) {
      console.log('Recaptcha not found, configuring...');
      await configureCaptcha(); // Make sure captcha is ready
    }
    const appVerifier = window.recaptchaVerifier
    
    let newNumber = countryCode + mobileNumber
    const confirmationResult = await firebase.auth().signInWithPhoneNumber(newNumber, appVerifier);

    const userToken = RandomNumber(32);

    const userData = {
      firebaseToken: confirmationResult.verificationId,
      mobileNumber,
      countryCode,
      userToken,
    };
    dispatch({ type: 'SAVE_OTP', payload: userData });

    toast.success(
      frontLabelsName?.find((e) => e.key === 'lbl_otp_has_been_sent')?.value || 'OTP has been sent!'
    );

    window.confirmationResult = confirmationResult;

    setTimeout(() => {
      history.push('/new-registration-otp-verification');
    }, 1000);
    setLoading(false)
  } catch(err)  {
    setLoading(false)
    console.log(err)
    if (
      err.message ==
      'The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].'
    ) {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter(
              (e) =>
                e.key ==
                'lbl_the_format_of_the_phone_number_provided_is_incorrect'
            ).length > 0
            ? frontLabelsName.filter(
                (e) =>
                  e.key ==
                  'lbl_the_format_of_the_phone_number_provided_is_incorrect'
              )[0]['value'] ||
              'lbl_the_format_of_the_phone_number_provided_is_incorrect'
            : 'lbl_the_format_of_the_phone_number_provided_is_incorrect'
          : 'lbl_the_format_of_the_phone_number_provided_is_incorrect'
      )
    } else {
    console.log(err.message)
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err.message).length > 0
            ? frontLabelsName.filter((e) => e.key == err.message)[0][
                'value'
              ] || err.message
            : err.message
          : err.message
      )
    }
    setError_phone_number('')
  



      // firebase
      //   .auth()
      //   .signInWithPhoneNumber(newNumber, appVerifier)
      //   .then((confirmationResult) => {
      //     const userToken = RandomNumber(32)

      //     let userData = {
      //       firebaseToken: confirmationResult.verificationId,
      //       mobileNumber,
      //       countryCode,
      //       userToken,
      //     }
      //     dispatch({ type: 'SAVE_OTP', payload: userData })
 
      //     toast.success(
      //       frontLabelsName
      //         ? frontLabelsName.filter((e) => e.key == 'lbl_otp_has_been_sent')
      //             .length > 0
      //           ? frontLabelsName.filter((e) => e.key == 'lbl_otp_has_been_sent')[0][
      //               'value'
      //             ] || 'lbl_otp_has_been_sent'
      //           : 'lbl_otp_has_been_sent'
      //         : 'lbl_otp_has_been_sent'
      //     )
      //     window.confirmationResult = confirmationResult

      //     setTimeout(() => {
      //       history.push('/registration/new-registration-otp-verification')
      //     }, 1000)
      //     setLoading(false)
      //   })
   
    }
  }}

  if (isAuthenticated && !loading) {
    return <Redirect to="/renters-info" />
  }

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container mb-5 pt-5">
        <div className="row">
          <ToastifyContainer />

          <div className="main-otp-box">
            <div className="otp-box-rg-new">
              <form>
              <h4 style={{textAlign:"center",marginBottom:"18px"}}>
                    <strong>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == 'lbl_register_for_free_on_the_tenant_register'
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_register_for_free_on_the_tenant_register'
                            )[0]['value'] || 'lbl_register_for_free_on_the_tenant_register'
                          : 'lbl_register_for_free_on_the_tenant_register'
                        : 'lbl_register_for_free_on_the_tenant_register'}
                    </strong>
                  </h4>
                <div className="img-mob text-center">
                  <img src="assets/verification.svg" alt="mobile" />
                  <h2>
                    <strong>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == 'lbl_otp_verification'
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_otp_verification'
                            )[0]['value'] || 'lbl_otp_verification'
                          : 'lbl_otp_verification'
                        : 'lbl_otp_verification'}
                    </strong>
                  </h2>
                  <p className="color-set-otp">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == 'lbl_we_will_send')
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == 'lbl_we_will_send'
                          )[0]['value'] || 'lbl_we_will_send'
                        : 'lbl_we_will_send'
                      : 'lbl_we_will_send'}
                    &nbsp;
                    <strong>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == 'lbl_otp').length >
                          0
                          ? frontLabelsName.filter((e) => e.key == 'lbl_otp')[0][
                              'value'
                            ] || 'lbl_otp'
                          : 'lbl_otp'
                        : 'lbl_otp'}
                    </strong>
                    <br />
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == 'lbl_on_this_mobile')
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == 'lbl_on_this_mobile'
                          )[0]['value'] || 'lbl_on_this_mobile'
                        : 'lbl_on_this_mobile'
                      : 'lbl_on_this_mobile'}
                  </p>
                  <p className="color-set-otp">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == 'lbl_enter_mobile_no')
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == 'lbl_enter_mobile_no'
                          )[0]['value'] || 'lbl_enter_mobile_no'
                        : 'lbl_enter_mobile_no'
                      : 'lbl_enter_mobile_no'}
                  </p>

                  <div className="d-flex align-items-center justify-content-around">
                    <select
                      className="form-select new-padding-class"
                      style={{ maxWidth: 200 }}
                      onChange={(e) => {
                        setCountryCode('+' + e.target.value)
                        setError_phone_number('')
                      }}
                     
                    >
                      {countryCodes.map((country, i) => (
                        <option value={country.phonecode} key={i}>
                          {country.name + ' (+' + country.phonecode + ')'}
                        </option>
                      ))}
                    </select>

                    <input
                      type="number"
                      value={mobileNumber}
                      onChange={(e) => {
                        setMobileNumber(e.target.value)
                        if (mobileNumber.length > 5) {
                          setError_phone_number('')
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(
                            0,
                            e.target.maxLength
                          )
                      }}
                      maxlength={15}
                    />
                  </div>

                  {error_phone_number && !loading1 && (
                    <div className="mt-3">
                      <span style={{ color: 'red' }}>{error_phone_number}</span>
                    </div>
                  )}

                  <div className="button-set pt-5 d-flex justify-content-center">
           
                    <Button
                      onClick={handleOtp}
                      disabled={loading1}
                      type="submit"
                      className="d-flex align-items-center justify-content-center"
                 
                    >
                      {loading1 ? (
                                              <CircularProgress
                                                size={24}
                                                sx={{
                                                  ":hover": { color: "#000" },
                      
                                                  color: "#000",
                                                 
                                                }}
                                              />
                                            ) : frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == 'lbl_get_otp')
                            .length > 0
                          ? frontLabelsName.filter((e) => e.key == 'lbl_get_otp')[0][
                              'value'
                            ] || 'lbl_get_otp'
                          : 'lbl_get_otp'
                        : 'lbl_get_otp'}
                    </Button>
           
                  </div>
                </div>
              </form>
              <div ref={reCaptchRef}>
                <div id="sign-in-button"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
})

export default connect(mapStateToProps, {})(New_registration_otp)
